import { CUSTOM_FIELD_IDS } from './constants';

export const getCustomFieldValue = (customFields, fieldId) => {
  if (!customFields) return '';
  const field = customFields.find((f) => f.id === fieldId);
  return field?.value || '';
};

export const parsePipeList = (value) => {
  if (!value) return [];
  if (typeof value === 'string') {
    return value
      .split(/[|,]/)
      .map((item) => item.trim())
      .filter((item) => item);
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [];
};

// Like parsePipeList but splits ONLY on the explicit bullet separators "*" and
// "|" — never on commas. Commas are natural language inside an item (e.g.
// "Confidence Building, Personal Empowerment, and Emotional Wellness") and must
// be preserved. Use this for free-text fields where "*" denotes bullet points.
export const parseBulletList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === 'string') {
    return value
      .split(/[*|]/)
      .map((item) => item.trim())
      .filter((item) => item);
  }
  return [];
};

export const ensureHttpProtocol = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return `https://${url}`;
};

export const extractPractitionerData = (user, decodedName) => {
  const getField = (fieldId) => getCustomFieldValue(user?.customFields, fieldId);

  return {
    fullName: user?.name || `${user?.firstName} ${user?.lastName}` || decodedName,
    firstName: user?.firstName || '',
    email: user?.email || '',
    phone: user?.phone || '',
    avatar: user?.profilePhoto || getField(CUSTOM_FIELD_IDS.avatar),
    avatarPosition: user?.avatarPosition || '', // object-position chosen in the dashboard
    website: user?.website || '',
    address: user?.address || '',
    fullBio: getField(CUSTOM_FIELD_IDS.fullBio) || user?.bio || '',
    personalStory: getField(CUSTOM_FIELD_IDS.personalStory) || '',
    specialties: user?.specialties || getField(CUSTOM_FIELD_IDS.specialties),
    title: getField(CUSTOM_FIELD_IDS.title),
    education: getField(CUSTOM_FIELD_IDS.education),
    certifications: getField(CUSTOM_FIELD_IDS.certifications),
    memberships: getField(CUSTOM_FIELD_IDS.memberships),
    practitionerTypes: getField(CUSTOM_FIELD_IDS.practitionerTypes),
    languages: getField(CUSTOM_FIELD_IDS.languages),
    instagram: getField(CUSTOM_FIELD_IDS.instagram) || getField(CUSTOM_FIELD_IDS.instagramAlt),
    linkedin: getField(CUSTOM_FIELD_IDS.linkedin),
    twitter: getField(CUSTOM_FIELD_IDS.twitter),
    facebook: getField(CUSTOM_FIELD_IDS.facebook),
    hourlyRate: user?.hourlyRate || '',
  };
};
